var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconJumpBack10Sec = function SvgIconJumpBack10Sec(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.137 4.88q2.637.035 4.64 1.547 2.004 1.476 2.813 3.867l-1.758.598a6 6 0 0 0-2.18-2.953q-1.511-1.16-3.515-1.196a6.3 6.3 0 0 0-2.11.422 6.5 6.5 0 0 0-1.757.985l1.968 1.968H5V4.88l1.934 1.934a8.9 8.9 0 0 1 2.355-1.407 7.7 7.7 0 0 1 2.848-.527m-1.899 6.75v7.488H8.762v-5.976H7.25V11.63zm6.012 1.512v4.5q0 .633-.422 1.054-.421.422-1.09.422h-1.476q-.633 0-1.09-.422a1.43 1.43 0 0 1-.422-1.054v-4.5q0-.633.422-1.055a1.49 1.49 0 0 1 1.09-.457h1.476q.669 0 1.09.457.422.422.422 1.055m-2.988 0v4.5h1.476v-4.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconJumpBack10Sec);
export { ForwardRef as ReactComponent };